<div class="px-2 sm:px-20">
  <h1
    class="text-center cursor-pointer mt-8 font-bold text-5xl text-white underline"
    (click)="goToHome()"
  >
    {{ appName }}
  </h1>
  <div class="mt-6 md:mt-8">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Include TW dynamic classes -->
<div style="display: none" class="bg-blue-500 p-3"></div>
